import * as z from 'zod';

export const addressTypeSchema = z.union([z.literal('physical'), z.literal('mailing'), z.literal('other')]);

export type AddressTypeSchema = z.infer<typeof addressTypeSchema>;
